import { mapState } from 'vuex';

export default {
  data() {
    return {
      dlPrecison: 10, //结算单价精度
    };
  },
  mounted() {
    if (this.userInfo.businessGroup == '物贸') {
      this.dlPrecison = 8;
    } else {
      this.dlPrecison = 10;
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo.userInfo,
    }),
    validRules() {
      return {
        invoiceDesc: [{ required: true, message: '请输入产品名称' }],
        invoiceQuantity: [{ required: true, message: '请输入数量' }],
        invoiceAmount: [{ required: true, message: '请输入含税金额' }],
        taxRate: [{ required: true, message: '请输入税率' }],
        invoiceUnitPrice: [{ required: true, message: '请输入结算单价' }],
        expenseItem: [{ required: true, message: '请输入结算单价', trigger: ['blur', 'change'] }],
        goodsName: [{ required: true, message: '请输入商品名称' }],
        invoiceUnit: [
          {
            required: this.userInfo.businessGroup == '多式联运' ? true : false,
            message: '请输入单位',
          },
        ],
      };
    },
    maxHeight() {
      return window.innerHeight / 2 + 'px';
    },
    columnList() {
      return [
        { type: 'checkbox', width: 50 },
        {
          title: '序号',
          field: 'sortNo',
          type: 'seq',
          width: 60,
        }, //序号
        {
          width: 120,
          field: 'receivableSettlementLineId',
          title: '结算单行号',
        },
        {
          width: 120,
          field: 'receivableSettlementNo',
          title: '结算单编号',
        },
        // invoiceDesc 物贸中为产品名称，多式联运中为费用项目
        {
          // 开票描述
          field: 'invoiceDesc',
          title: '产品名称',
          width: 150,
          visible: this.userInfo.businessGroup == '物贸',
          editRender: {
            name: 'ElInput',
            props: {
              clearable: true,
            },
          },
          slots: {
            default: ({ row }) => {
              return [<span>{row.invoiceDesc}</span>];
            },
            edit: ({ row }) => {
              return [
                <el-input
                  value={row.invoiceDesc}
                  onInput={(val) => this.updateCol(row, val, 'invoiceDesc')}
                ></el-input>,
              ];
            },
          },
        },
        // invoiceDesc 物贸中为产品名称，多式联运中为费用项目
        {
          field: 'invoiceDesc',
          title: '费用项目',
          width: 120,
          visible: this.userInfo.businessGroup == '多式联运',
          editRender: {
            name: 'ElSelect',
            options: this.expenseItemList,
            props: {
              clearable: true,
              filterable: true,
            },
            events: {
              change: (obj) => {
                this.updateCol(obj.row, obj.row['expenseItem'], 'expenseItem');
              },
            },
          },
        },
        {
          field: 'goodsName',
          title: '商品名称',
          width: 120,
          visible: this.userInfo.businessGroup == '多式联运',
          editRender: {
            name: 'ElInput',
            props: {
              clearable: true,
            },
          },
          slots: {
            default: ({ row }) => {
              return [<span>{row.goodsName}</span>];
            },
            edit: ({ row }) => {
              return [
                <el-input
                  value={row.goodsName}
                  onInput={(val) => this.updateCol(row, val, 'goodsName')}
                ></el-input>,
              ];
            },
          },
        },
        {
          title: '规格',
          field: 'productSpecificationModel',
          width: 120,
          editRender: {
            name: 'ElInput',
            props: {
              clearable: true,
            },
          },
          slots: {
            default: ({ row }) => {
              return [<span>{row.productSpecificationModel}</span>];
            },
            edit: ({ row }) => {
              return [
                <el-input
                  value={row.productSpecificationModel}
                  onInput={(val) => this.updateCol(row, val, 'productSpecificationModel')}
                ></el-input>,
              ];
            },
          },
        }, //规格型号
        {
          title: '单位',
          field: 'invoiceUnit',
          width: 120,
          editRender: {
            name: 'ElInput',
            props: { clearable: true },
          },
          slots: {
            default: ({ row }) => {
              return [<span>{row.invoiceUnit}</span>];
            },
            edit: ({ row }) => {
              return [
                <el-input
                  value={row.invoiceUnit}
                  onInput={(val) => this.updateCol(row, val, 'invoiceUnit')}
                ></el-input>,
              ];
            },
          },
        }, //单位
        {
          title: this.userInfo.businessGroup == '物贸' ? '数量' : '本次结算数量',
          field: 'invoiceQuantity',
          width: 120,
          editRender: { name: 'ElInput', props: { clearable: true } },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span>
                  {this.replaceLastZeroStr(
                    this.$baseRequest.formatTableColumn(row.invoiceQuantity, 3)
                  )}
                </span>,
              ];
            },
            edit: ({ row }) => {
              return [
                <input-number-ad
                  value={row['invoiceQuantity']}
                  placeholder="请输入"
                  clearable={true}
                  precision={8}
                  max={9999999999}
                  min={0}
                  maxLength={10}
                  onInput={(val) => this.updateCol(row, val, 'invoiceQuantity')}
                ></input-number-ad>,
              ];
            },
          },
        }, //结算数量

        {
          title: '结算单价(含税)',
          field: 'invoiceUnitPrice',
          width: 120,
          editRender: { name: 'ElInput', props: { clearable: true } },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span>
                  {this.replaceLastZeroStr(
                    this.$baseRequest.formatTableColumn(row.invoiceUnitPrice, this.dlPrecison)
                  )}
                </span>,
              ];
            },
            edit: ({ row }) => {
              return [
                <input-number-ad
                  value={row['invoiceUnitPrice']}
                  placeholder="请输入"
                  clearable={true}
                  precision={this.dlPrecison}
                  max={9999999999}
                  min={0}
                  maxLength={10}
                  onInput={(val) => this.updateCol(row, val, 'invoiceUnitPrice')}
                ></input-number-ad>,
              ];
            },
          },
        }, //含税单价
        {
          title: '不含税金额',
          field: 'excludedTaxAmount',
          width: 120,
          // editRender: { name: 'ElInput', props: { clearable: true } },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span>
                  {this.replaceZeroStr(this.$baseRequest.formatTableColumn(row.excludedTaxAmount))}
                </span>,
              ];
            },
            // edit: ({ row }) => {
            //   return [
            //     <input-number-ad
            //       value={row['excludedTaxAmount']}
            //       placeholder="请输入"
            //       clearable={true}
            //       precision={this.$globalVar.aPoint}
            //       max={9999999999}
            //       min={0}
            //       maxLength={10}
            //       onInput={(val) => this.updateCol(row, val, 'excludedTaxAmount')}
            //     ></input-number-ad>,
            //   ];
            // },
          },
        }, //不含税金额
        {
          title: '含税金额',
          field: 'invoiceAmount',
          width: 120,
          editRender: { name: 'ElInput', props: { clearable: true } },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span>
                  {this.replaceZeroStr(this.$baseRequest.formatTableColumn(row.invoiceAmount, 2))}
                </span>,
              ];
            },
            edit: ({ row }) => {
              return [
                <input-number-ad
                  value={row['invoiceAmount']}
                  placeholder="请输入"
                  clearable={true}
                  precision={this.$globalVar.aPoint}
                  max={9999999999}
                  min={0}
                  maxLength={10}
                  onInput={(val) => this.updateCol(row, val, 'invoiceAmount')}
                ></input-number-ad>,
              ];
            },
          },
        }, //含税总金额
        {
          title: '税率',
          field: 'taxRate',
          width: 120,
          editRender: { name: 'ElInput', props: { clearable: true } },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span>
                  {this.$baseRequest.formatTableColumn(row.taxRate, this.$globalVar.tPoint)}
                </span>,
              ];
            },
            edit: ({ row }) => {
              return [
                <input-number-ad
                  value={row['taxRate']}
                  placeholder="请输入"
                  clearable={true}
                  precision={this.$globalVar.tPoint}
                  max={1}
                  min={0}
                  maxLength={10}
                  onInput={(val) => this.updateCol(row, val, 'taxRate')}
                ></input-number-ad>,
              ];
            },
          },
        }, //税率
        {
          title: '备注',
          field: 'mark',
          width: 500,
          editRender: { name: 'ElInput', props: { clearable: true } },
          slots: {
            default: ({ row }) => {
              return [<span>{row.mark}</span>];
            },
            edit: ({ row }) => {
              return [
                <el-input
                  value={row.mark}
                  onInput={(val) => this.updateCol(row, val, 'mark')}
                ></el-input>,
              ];
            },
          },
        }, //备注
      ];
    },
  },
};
